import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/api/client";

const SESSION_KEY = "zt_session_id";

function getSessionId() {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

function getDeviceType() {
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk/i.test(ua)) return "tablet";
  if (/mobile|iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(ua)) return "mobile";
  return "desktop";
}

export function useFootfall() {
  const location = useLocation();

  useEffect(() => {
    const payload = {
      session_id: getSessionId(),
      page_path: location.pathname + location.search,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      device_type: getDeviceType(),
    };

    api.post("/footfall/track", payload).catch(() => {
      // Silently fail — footfall should never break the UI
    });
  }, [location.pathname, location.search]);
}
